'use client'

import type { FreestarSlotConfig } from './types'

const FREESTAR_GLOBAL_DEFAULTS = {
    queue: [] as Array<() => void>,
    config: {
        enabled_slots: [],
    },
}

export function ensureFreestarGlobal(target: Pick<Window, 'freestar'> = window) {
    const freestar = target.freestar || {
        queue: [...FREESTAR_GLOBAL_DEFAULTS.queue],
        config: { enabled_slots: [...FREESTAR_GLOBAL_DEFAULTS.config.enabled_slots] },
    }

    freestar.queue = freestar.queue || []
    freestar.config = freestar.config || { enabled_slots: [] }
    freestar.config.enabled_slots = freestar.config.enabled_slots || []
    freestar.initCallback =
        freestar.initCallback ||
        (() => {
            freestar.initCallbackCalled = true
        })
    target.freestar = freestar
    return freestar
}

export function invokeFreestarSlot(slot: FreestarSlotConfig, target?: Pick<Window, 'freestar'>) {
    const freestar = ensureFreestarGlobal(target)
    const command = () => {
        if (slot.kind === 'sticky_footer') {
            freestar.newStickyFooter?.(slot.placementName)
            return
        }
        if (slot.kind === 'sticky_rail_right') {
            freestar.newStickyRail?.(slot.slotId)
            return
        }
        if (slot.kind === 'sticky_sidewall_right') {
            freestar.newSidewall?.(slot.slotId)
            return
        }
        freestar.newPushdown?.(slot.slotId)
    }

    freestar.queue.push(command)
    if (freestar.initCallbackCalled) {
        command()
    }
}

export function deleteFreestarSlots(
    slots: FreestarSlotConfig[],
    target?: Pick<Window, 'freestar'>,
    onError?: () => void
) {
    const freestar = ensureFreestarGlobal(target)
    const displaySlotIds = slots
        .filter((slot) => slot.kind !== 'sticky_footer' && slot.kind !== 'sticky_sidewall_right')
        .map(({ slotId }) => slotId)
    const stickyFooterPlacementNames = slots
        .filter((slot) => slot.kind === 'sticky_footer')
        .map(({ placementName }) => placementName)
    const sidewallPlacementNames = slots
        .filter((slot) => slot.kind === 'sticky_sidewall_right')
        .map(({ placementName }) => placementName)
    const command = () => {
        try {
            if (displaySlotIds.length > 0) {
                freestar.deleteAdSlots?.(displaySlotIds)
            }
            stickyFooterPlacementNames.forEach((placementName) => freestar.deleteStickyFooter?.(placementName))
            sidewallPlacementNames.forEach((placementName) => freestar.deleteSidewall?.(placementName))
        } catch {
            onError?.()
        }
    }

    freestar.queue.push(command)
    if (freestar.initCallbackCalled) {
        command()
    }
}
